import gql from 'graphql-tag';

export const FRAGMENT_VARIATION_COMPLIANCE = gql`
  fragment VariationCompliance on Variation {
    id
    complianceStatus
    complianceProgressPercentage
    complianceError {
      type
      message
    }
  }
`;

// A long-form asset carries no `complianceError`: the backend computes its status on read, so a
// failure surfaces as the status itself rather than as a stored error.
export const FRAGMENT_LONG_FORM_ASSET_COMPLIANCE = gql`
  fragment LongFormAssetCompliance on LongFormAsset {
    id
    complianceStatus
    complianceProgressPercentage
  }
`;

export const FRAGMENT_BLOG_DRAFT_COMPLIANCE = gql`
  fragment BlogDraftCompliance on BlogPostBuilderDraft {
    id
    complianceStatus
    complianceProgressPercentage
    complianceError {
      type
      message
    }
  }
`;
